import React from "react";
import { Bouncer } from "@/components/Bouncer";

export const PageLoader = () => (
  <div
    className="align-center flex h-screen w-screen items-center justify-center bg-page-loader"
    role="status"
    data-testid="loading-spinner"
  >
    <Bouncer />
    <span className="sr-only">Loading...</span>
  </div>
);
